"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getMatchValue = void 0;
var react_1 = __importDefault(require("react"));
var Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
var Tab_1 = __importDefault(require("@material-ui/core/Tab"));
var react_router_dom_1 = require("react-router-dom");
exports.getMatchValue = function (value, pathname, exact) {
    if (exact === true) {
        return value;
    }
    var re = new RegExp("^" + value + ".*", 'g');
    var match = pathname.match(re);
    return match === null ? value : pathname;
};
exports["default"] = (function (props) {
    var tabs = props.tabs, prefix = props.prefix, _a = props.exact, exact = _a === void 0 ? true : _a;
    return (react_1["default"].createElement(react_router_dom_1.Route, { path: '/', render: function (_a) {
            var location = _a.location;
            var pathname = location.pathname;
            return (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(Tabs_1["default"], { value: pathname, indicatorColor: "primary", textColor: "primary", variant: "scrollable", scrollButtons: "auto", "aria-label": "scrollable auto tabs example" }, tabs.map(function (t, i) {
                    var value = prefix + t.link;
                    var matchValue = exports.getMatchValue(value, pathname, exact);
                    return (react_1["default"].createElement(Tab_1["default"], { key: i, label: t.label, value: matchValue, to: value, component: react_router_dom_1.Link }));
                })),
                react_1["default"].createElement(react_router_dom_1.Switch, null, tabs.map(function (t, i) { return (react_1["default"].createElement(react_router_dom_1.Route, { key: i, exact: exact, path: prefix + t.link, render: function () { return t.Component; } })); }))));
        } }));
});
